import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import moment from 'moment';
import { AdminService } from '../../../../modules/administration/services/admin.service';

@Component({
  selector: 'app-inactive-related-service-dialogbox',
  templateUrl: './inactive-related-service-dialogbox.component.html',
  styleUrls: ['./inactive-related-service-dialogbox.component.scss'],
  standalone: false,
})
export class InactiveRelatedServiceDialogboxComponent {
  @Input() relatedServiceSelection: string[];
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  form: FormGroup;
  loadSpinner: boolean;
  constructor(private adminService: AdminService, private fb: FormBuilder) {
    this.form = this.fb.group({
      effectiveDate: [null],
    });
  }
  inactive(): void {
    this.loadSpinner = true;
    this.adminService
      .inactiveRelatedServices(
        moment(this.form.get('effectiveDate').value).format('MM/DD/YYYY'),
        this.relatedServiceSelection
      )
      .subscribe(() => {
        this.loadSpinner = false;
        this.closeDialog.emit(false);
      });
  }
  onCloseDialog(): void {
    this.closeDialog.emit(false);
  }
}
